<template>
  <header>
    <nav class="navbar navbar-expand-md navbar-light">
      <div class="container-fluid align-items-center">
        <router-link to="/Home" class="navbar-brand">
          <img
            :src="$t('Header.BrandLogo')"
            alt="Danone Big Ten Logo"
            class="img-fluid"
          />
        </router-link>

        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbar-Nav"
          @click="toggleCollapse"
          aria-controls="navbar-Nav"
          :aria-expanded="isCollapsed"
          aria-label="Toggle navigation"
          :class="{ active: isCollapsed }"
          v-if="!$route.meta.hideNav"
        >
          <span class="toggler-bar"></span>
          <span class="toggler-bar"></span>
          <span class="toggler-bar"></span>
        </button>

        <div
          :class="{ show: isCollapsed }"
          class="collapse navbar-collapse justify-content-end my-2"
          id="navbar-Nav"
          v-if="!$route.meta.hideNav"
        >
          <ul class="navbar-nav justify-content-end align-items-center">
            <li class="nav-item">
              <router-link to="/Home" class="nav-link" @click="closeMenu">
                {{ $t('Header.HomeTab') }}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/Upload" class="nav-link" @click="closeMenu">
                {{ $t('Header.UploadTab') }}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/Support" class="nav-link" @click="closeMenu">
                {{ $t('Header.SupportTab') }}
              </router-link>
            </li>
            <!-- <li class="nav-item dropdown ms-md-3 lang-dropdown-item">
              <a class="nav-link dropdown-toggle d-flex align-items-center py-1" href="#" id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                <span class="globe-icon me-1">🌐</span>
                <span class="text-uppercase">{{ currentLang }}</span>
              </a>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdownMenuLink">
                <li><button class="dropdown-item text-uppercase" :class="{ active: currentLang === 'en' }" @click="changeLanguage('en')">EN</button></li>
                <li><button class="dropdown-item text-uppercase" :class="{ active: currentLang === 'fr' }" @click="changeLanguage('fr')">FR</button></li>
              </ul>
            </li> -->
          </ul>
        </div>
      </div>
    </nav>
  </header>

  <banner></banner>
</template>

<script>
import banner from '../UI/Banner.vue';
import { useI18n } from 'vue-i18n';
import { ref, watch, onMounted } from 'vue';
import { loadLocaleMessages } from '@/main.js';

export default {
  components: { banner },
  setup() {
    const { locale, t } = useI18n();
    const currentLang = ref(locale.value);
    const isCollapsed = ref(false); // ✅ Define state for toggle

    const toggleCollapse = () => {
      isCollapsed.value = !isCollapsed.value;
      handleBodyScroll();
    };

    const closeMenu = () => {
      isCollapsed.value = false;
      handleBodyScroll();
    };

    const handleBodyScroll = () => {
      if (isCollapsed.value) {
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
      }
    };

    const changeLanguage = async (lang) => {
      if (currentLang.value === lang) return;

      await loadLocaleMessages(lang);
      locale.value = lang;
      localStorage.setItem('locale', lang);
      currentLang.value = lang;
      injectGTM();
    };

    watch(locale, (newLocale) => {
      currentLang.value = newLocale;
    });

    onMounted(() => {
      injectGTM();
    });

    const injectGTM = () => {
      const gtmId = t('gtmId');
      if (!gtmId) return;

      document.querySelectorAll('[data-gtm]').forEach((el) => el.remove());

      const script = document.createElement('script');
      script.setAttribute('data-gtm', gtmId);
      script.innerHTML = `
        (function (w, d, s, l, i) {
          w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
          var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; 
          j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; 
          f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', '${gtmId}');
      `;
      document.head.appendChild(script);

      const noscript = document.createElement('noscript');
      noscript.setAttribute('data-gtm', gtmId);
      noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
      document.body.prepend(noscript);
    };

    return {
      currentLang,
      changeLanguage,
      isCollapsed,
      toggleCollapse,
      closeMenu,
    };
  },
};
</script>
